import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent,  PageSettingsModel,  SelectionSettingsModel,  ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { Comunidad, GridPageSettings, MenuFuncionCodes, SearchComunidadPublicacionItemDto, SearchComunidadPublicacionRequestDto, SearchComunidadRequest } from '../../../../src/app/shared/model';
import { ComunidadPublicacionService, ComunidadService, MenuFuncionService } from '../../../../src/app/shared/services';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
    selector: 'app-comunidadPublicacionLista',
    templateUrl: './comunidadPublicacionLista.component.html'
})

export class ComunidadPublicacionListaComponent{
    @ViewChild('grid')
    public grid: GridComponent;
    isValidating: boolean;
    canAdd: boolean;
    canView: boolean;
    verSoloActivos: boolean = false;
    public query: Query;
    searchForm: FormGroup;
    data: DataManager;

    public selectionOptions: SelectionSettingsModel;
    pageSizes: number[];
    public pageSettings: PageSettingsModel;
    //pageSettings: { pageCount: number; pageSize: number; pageSizes: number[]; };
    toolbarOptions: ToolbarItems[];

    comunidadList: Comunidad[] //Edificios
    isComunidadSearching: boolean; //Edificios
    isExporting: boolean;

    constructor(
        private menuService:MenuFuncionService,
        private sharedFunctions:SharedFunctions,
        private router:Router,
        private formBuilder:FormBuilder,
        private service: ComunidadPublicacionService,
        private comunidadService: ComunidadService,
        private datePipe: DatePipe
    ){}

    ngOnInit(): void{
        this.isValidating = true;
        this.menuService.checkMenuPadre(MenuFuncionCodes.COMUNIDAD_PUBLICACIONES).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data?.Result){
                this.canAdd = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_PUBLICACIONES_ADD);
                this.canView = data.Result.some(x => x == MenuFuncionCodes.COMUNIDAD_PUBLICACIONES_LIST);
                  if (this.canView){
                    this.loadView();
                  } else {
                    this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                    this.router.navigate(['/']);
                  }
            }
            else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.router.navigate(['/']);
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }
    loadView() {
        this.buildForm();
        this.pageSizes = GridPageSettings.PageSizeList;
        this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

        this.setQueryParams();
        this.data = new DataManager({
            url: this.service.getSearchUrl(),
            adaptor: new WebApiAdaptor(),
            headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
        });

        this.getComunidades();
    }

    //Edificios
    getComunidades() {
        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
            this.isComunidadSearching = false;
            if(data != null)
                this.comunidadList = data?.result;
        },(err: HttpErrorResponse) => {
            this.isComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    clearDate(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
                this.searchForm.get(formFieldName)?.setValue(null);
        }
    }

    buildForm() {
        this.searchForm = this.formBuilder.group({
            'FechaDesde': [null],
            'FechaHasta': [null],
            'ComunidadId': [null]
        });
    }

    onGridActionFailure(event: any): void {
        this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
    }

    onSearch() {
        this.setQueryParams();
        this.grid.refresh();
    }

    onSentSearch() {
        this.verSoloActivos = false;
        this.onSearch();
    }

    setQueryParams() {
        if (this.query == null)
            this.query = new Query();

        //debugger;
        var index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
        if (index >= 0)
            this.query.params[index].value = this.verSoloActivos.toString();
        else
            this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());

        index = this.query.params.findIndex(obj => obj.key === "FechaDesde");
        if(index >= 0)
            this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd");
        else
            this.query.addParams("FechaDesde", this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd"));

        index = this.query.params.findIndex(obj => obj.key === "FechaHasta");
        if(index >= 0)
            this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd");
        else
            this.query.addParams("FechaHasta", this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd"));

        index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
        if(index >= 0)
            this.query.params[index].value = this.searchForm.value.ComunidadId;
        else
            this.query.addParams("ComunidadId", this.searchForm.value.ComunidadId);
    }

    add() {
        if (this.canAdd)
            this.router.navigate(['comunidad-publicacion-edit', 0]);
        else
            this.sharedFunctions.showMessage("No puede ejecutar esta operación", "Error");
    }

    view(item: SearchComunidadPublicacionItemDto){
        if(!item || item.Id == null || item.Id <= 0){
            this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
            return false;
        }
        this.router.navigate(['comunidad-publicacion-edit', item.Id]);
    }

    onExport() {
        var search = new SearchComunidadPublicacionRequestDto(null, null, null, "", this.verSoloActivos, true, null, "", null, null, null);
        search = Object.assign(search, this.searchForm.value);

        this.isExporting = true;
        this.service.exportSearch(search).subscribe((data: Blob) => {
            this.isExporting = false;
            var fileUrl = URL.createObjectURL(data);

            var anchor = document.createElement("a");
            anchor.download = "Comunidad_Publicacion_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
            anchor.href = fileUrl;
            anchor.click();
        },
        (err: HttpErrorResponse) => {
            this.isExporting = false;
            this.sharedFunctions.handleError(err, true);
        })
    }
}

